import {friendlyPhone} from "../../../lib/utils"
import { useState } from "react"
import { motion } from "framer-motion"
import {spring} from "../../../lib/styling/animations"

const sharedTwilioNumber = "+18337081234"

export type LinkedNumber = {
  phoneNumber: string
  friendlyName: string
  webHooksLinked: boolean
}

type TwilioLinkedNumbersProps = {
  linkedNumbers: LinkedNumber[]
  onRemove: (phoneNumber: string) => unknown
}

export default function TwilioLinkedNumbers({
  linkedNumbers = [], 
  onRemove
}: TwilioLinkedNumbersProps): JSX.Element {
  const [confirmRemoveList, setConfirmRemoveList] = useState<string[]>([])

  return (
    <section className="box-content w-3/4 flex flex-col items-start p-4 mt-4">
      <h2>{"Linked Phone Numbers"}</h2>
      <div className="flex items-center flex-wrap w-full">
        <span className="flex flex-col ml-2 mt-2 text-base bg-ppt-blue-900 p-4">
          {friendlyPhone(sharedTwilioNumber)}
          <span className="text-sm text-ppt-success">{"(Shared Number)"}</span>
        </span>
        {linkedNumbers.map(({ friendlyName, phoneNumber }) => (
          <motion.span
            key={phoneNumber}
            className="flex flex-col ml-2 mt-2 text-base bg-ppt-blue-900 p-4"
            layout
            transition={spring}
          >
            {friendlyName}
            {confirmRemoveList.some((num) => num === phoneNumber) ? (
              <motion.div className="flex flex-col items-center " layout>
                <span className="w-48 text-sm">
                  Are you sure? Lead mangets with this number will stop working.
                </span>
                <div className="flex w-full items-center justify-end px-4">
                  <button
                    onClick={() => onRemove(phoneNumber)}
                    className="font-display text-ppt-red hover:text-ppt-caution text-sm mr-2"
                  >
                    yes
                  </button>
                  <button
                    onClick={() =>
                      setConfirmRemoveList((prev) =>
                        prev.filter((num) => num !== phoneNumber)
                      )
                    }
                    className="font-display text-ppt-blue hover:text-ppt-success text-sm"
                  >
                    no
                  </button>
                </div>
              </motion.div>
            ) : (
              <button
                onClick={() =>
                  setConfirmRemoveList((prev) => [...prev, phoneNumber])
                }
                className="font-display text-ppt-blue hover:text-ppt-caution text-sm"
              >
                Remove
              </button>
            )}
          </motion.span>
        ))}
      </div>
    </section>
  )
}